
<app-header1></app-header1> 
<div class="wel-main">
    <div class="container-fuild banner">
      <div
        class="container d-flex flex-lg-row flex-sm-column flex-column justify-content-center align-items-center" >
        <div class="w-50 w-md-75">
          <div class="">
            <div class="">
              <!-- <div class="d-flex flex-row justify-content-start mb-2 ">
              <h1 class="">Top5 Colleges</h1>
            </div> -->
             
            </div>
          
          <div class="login-expired" >
            <div class="text-danger">
              <!-- <<svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-8 h-8 err-icon">
                <path stroke-linecap="round" stroke-linejoin="round" d="M9 12.75L11.25 15 15 9.75M21 12c0 1.268-.63 2.39-1.593 3.068a3.745 3.745 0 01-1.043 3.296 3.745 3.745 0 01-3.296 1.043A3.745 3.745 0 0112 21c-1.268 0-2.39-.63-3.068-1.593a3.746 3.746 0 01-3.296-1.043 3.745 3.745 0 01-1.043-3.296A3.745 3.745 0 013 12c0-1.268.63-2.39 1.593-3.068a3.745 3.745 0 011.043-3.296 3.746 3.746 0 013.296-1.043A3.746 3.746 0 0112 3c1.268 0 2.39.63 3.068 1.593a3.746 3.746 0 013.296 1.043 3.746 3.746 0 011.043 3.296A3.745 3.745 0 0121 12z" />
              </svg>> -->
             <img src="https://cdn.virtueanalytics.com/cache/payment-icon-message.png">
              <h5 class="inline-block mt-2 ">Welcome to the <strong> Top5 tool</strong>. <br> The credentials have been mailed to you on your registered email ID.</h5>
              </div>
            <div class="clickto mb-3 mt-2">
                Please contact us at <a href="mailto:info@virtueanalytics.com">info@virtueanalytics.com
                </a><br>if you have any trouble logging in.<br>Click here to <button (click)="redirectLogin()" class="dropbtn btn-login"><i class="fa fa-sign-in mr-1"></i> Login </button>
            </div>
          </div>
        </div>
      </div>
  
    </div>
  </div>
</div>
<app-footer></app-footer>
